import { Routes } from '@angular/router';
import { AppIconGenerator } from 'jk-life';
import { AppPage, AuthGuardService, jkGlb, LazyModuleConfig, LoginFormPage, OrmService } from 'jk-service';

export let orm: OrmService = jkGlb.orm;//###

export const moduleConfigs: LazyModuleConfig[] = [
  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    preload: true,
    priority: 1
  },
  {
    path: 'jck',
    loadChildren: () => import('jck').then(m => m.JckModule),
    preload: false,
    priority: 2
  },
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    preload: false,
    priority: 3
  },
  {
    path: 'tax',
    loadChildren: () => import('tax').then(m => m.TaxModule),
    preload: false,
    priority: 4
  },
  {
    path: 'uty',
    loadChildren: () => import('uty').then(m => m.UtyModule),
    preload: false,
    priority: 5
  }
];

export const appPages: AppPage[] = [ // ###
  { title: 'Hindsight 查詢', url: '/utyjb55', icon: 'search', id: 'utyjb55', isCheckPower: false },
  { title: 'Hindsight 設定', url: '/utyjb56', icon: 'settings', id: 'utyjb56', isCheckPower: false },
  { title: '知識庫搜尋', url: '/utyjb53', icon: 'search', id: 'utyjb53', isCheckPower: false }, // mdq-search
  { title: '知識庫設定', url: '/utyjb54', icon: 'settings', id: 'utyjb54', isCheckPower: false }, // mdq-settings

  { title: '首頁', url: '/home', icon: 'home', id: 'home', isCheckPower: false, checked: true, hint: '一切從家開始', }, // ###
  { title: 'TODO桌面版', url: '/mtrki01', icon: 'receipt', id: 'mtrki01', isCheckPower: true, checked: true, hint: 'TODO桌面版' },
  { title: '問題反應單', url: '/mtrki02', icon: 'receipt', id: 'mtrki02', isCheckPower: true, checked: true, hint: '問題反應單' },
  { title: '番茄速記', url: '/pomodoro-notes', icon: 'timer', id: 'pomodoro-notes', isCheckPower: false, checked: true, hint: '專注計時與快速筆記' },
  {
    title: 'widgets測試',
    url: '/widgit',
    icon: '',
    id: 'widgit',
    isCheckPower: false,
  },
  {
    title: '各種鐘',
    url: '/all-clock',
    icon: '',
    id: 'all-clock',
    isCheckPower: false,
  },
  {
    title: '建檔範例',
    url: '/a-single',
    icon: 'question_answer',
    id: 'a-single',
    isCheckPower: true,
  },
  {
    title: '日曆calendar',
    url: '/calendar',
    id: 'calendar',
    icon: '',
    isCheckPower: false,
  },
  /*   {
    title: '定時工作建立',
    url: '/sysai85',
    id: 'sysai85',
    isCheckPower: true,
  },
 */
  {
    title: 'Markdown Editor',
    url: '/markdown-editor',
    icon: 'edit_note',
    id: 'markdown-editor',
    isCheckPower: false,
  },
  {
    title: '蕃茄鐘速記',
    url: '/pomodoro-notes',
    icon: 'timer',
    id: 'pomodoro-notes',
    isCheckPower: false,
    hint: '專注計時與快速筆記',
  },
  {
    title: 'App Icon 產生器',
    url: '/app-icon-generator',
    icon: 'apps',
    id: 'app-icon-generator',
    isCheckPower: false,
    hint: '產生各平台 App Icon PNG',
  },
  {
    title: '檔案總管與預覽(UTYJB27)',
    url: '/utyjb27',
    icon: 'folder',
    id: 'utyjb27',
    isCheckPower: false,
    hint: 'Server 檔案管理與預覽',
  },
];


// routes 的 path 都不要加 / 開頭
export const routes: Routes = [
  //{ path: 'login-form', component: LoginFormPage, },
  {
    path: '',
    loadComponent: () => import('./components/home/util-home.component').then(m => m.UtilHome),
    // canActivate: [ AuthGuardService ]
  },
  {
    path: 'pomodoro-notes',
    loadComponent: () => import('./components/pomodoro-notes/pomodoro-notes.component').then(m => m.PomodoroNotesComponent),
    data: { preload: false, priority: 7 },
  },
  /*{
    path: 'mtrki01',
    component: Mtrki01BillComponent,
  },
  {
    path: 'mtrki02',
    component: Mtrki02BillComponent,
  },*/
  {
    path: 'home',
    loadComponent: () => import('./components/home/util-home.component').then(m => m.UtilHome),
    // canActivate: [ AuthGuardService ]
  },
  // Lazy loaded feature modules

  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    data: { preload: true, priority: 1, preloadDelay: 0 }
  },
  {
    path: 'jck',
    loadChildren: () => import('jck').then(m => m.JckModule),
    data: { preload: false, priority: 2, preloadDelay: 1000 }
  },
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    data: { preload: false, priority: 3, preloadDelay: 2000 }
  },
  {
    path: 'tax',
    loadChildren: () => import('tax').then(m => m.TaxModule),
    data: { preload: false, priority: 4, preloadDelay: 3000 }
  },
  {
    path: 'uty',
    //loadChildren: () => import('./uty/uty.module').then(m => m.UtyModule),
    loadChildren: () => import('uty').then(m => m.UtyModule),
    data: { preload: false, priority: 5, preloadDelay: 4000 }
  },

  // Lazy loaded pages
  {
    path: 'widgit',
    loadComponent: () => import('./misc/widgit/widgit.component').then(m => m.WidgitComponent),
    data: { preload: false, priority: 7 }
  },
  {
    path: 'all-clock',
    loadComponent: () => import('./components/all-clock/all-clock.component').then(m => m.AllClockComponent),
    data: { preload: false, priority: 7 }
  },
  {
    path: 'jkattach',
    loadComponent: () => import('./components/jkattach/jkattach.component').then(m => m.JkattachComponent),
    data: { preload: false, priority: 8 }
  },
  /*{
    path: 'lazy-loading-dashboard',
    loadComponent: () => import('./components/lazy-loading-dashboard/lazy-loading-dashboard.component').then(m => m.LazyLoadingDashboardComponent),
    data: { preload: false, priority: 9 }
  },*/
  {
    path: 'markdown-editor',
    loadComponent: () => import('./components/markdown-editor/markdown-editor.component').then(m => m.MarkdownEditorComponent),
  },
  {
    path: 'pomodoro-notes',
    loadComponent: () => import('./components/pomodoro-notes/pomodoro-notes.component').then(m => m.PomodoroNotesComponent),
    data: { preload: false, priority: 7 },
  },
  {
    path: 'app-icon-generator',
    component: AppIconGenerator,
  },
  {
    path: 'file-manager',
    loadComponent: () => import('./components/file-manager/file-manager.component').then(m => m.FileManagerComponent),
    data: { preload: false, priority: 8 },
  },
  {
    path: 'utyjb27',
    loadComponent: () => import('./uty/utyjb27/utyjb27.component').then(m => m.Utyjb27Component),
    data: { preload: false, priority: 8 },
  },
  {
    path: 'utyjb53',
    loadComponent: () => import('uty').then(m => m.MdqSearchComponent),
    data: { preload: false, priority: 8, preloadDelay: 4000 },
  },
  {
    path: 'utyjb54',
    loadComponent: () => import('uty').then(m => m.MdqSettingsComponent),
    data: { preload: false, priority: 8, preloadDelay: 4000 },
  },
  {
    path: 'utyjb55',
    loadComponent: () => import('uty').then(m => m.Utyjb55Component),
    data: { preload: false, priority: 8, preloadDelay: 4000 },
  },
  {
    path: 'utyjb56',
    loadComponent: () => import('uty').then(m => m.Utyjb56Component),
    data: { preload: false, priority: 8, preloadDelay: 4000 },
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
